import { render, staticRenderFns } from "./V.vue?vue&type=template&id=753e97ce&scoped=true"
import script from "./V.vue?vue&type=script&lang=js"
export * from "./V.vue?vue&type=script&lang=js"
import style0 from "./V.vue?vue&type=style&index=0&id=753e97ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753e97ce",
  null
  
)

export default component.exports